import React,{useEffect} from 'react'
import { Box, useMediaQuery } from '@mui/material';
import UserManualNew from './components/user_manual_new';
import { useLocation } from 'react-router-dom';
import MainLayoutContainer from '../login-register/components/main-layout';
import Header from '../login-register/components/header';

const UserManualNewPage = () => {
  const isBigScreen = useMediaQuery('(min-width:1024px)');
  const location = useLocation();
  
  useEffect(() => {
      document.title = "User Manual";
      var link = !document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', document.location.protocol + '//' + document.location.host + document.location.pathname);
      // console.log(link);
      document.head.appendChild(link);
    }, []);
  
  return (
    <>
      {location.pathname === "/info-manual" ? (
        <MainLayoutContainer>
          <Header showLogin={true} showIntro={false}/>
          <Box
            sx={{
              display: 'flex',
              flexDirection: isBigScreen ? 'row' : 'column',
              height: 'calc(100vh - 120px)',
              width: '100%',
              marginTop: 8,
              background: '#132d5a',
              overflow: 'auto',
            }}
          >
            <UserManualNew />
          </Box>
        </MainLayoutContainer>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 48px)',
            width: '100%',
            marginTop: '48px',
            background: '#0d2147',
            overflow: 'auto',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              mt: 0,
              pt: 0,
              background: '#132d5a',
              width: '100%',
              height: '100%',
              overflow: 'auto',
              scrollBehavior: 'smooth',
              '&::-webkit-scrollbar': { width: 6, height: 6 },
              '&::-webkit-scrollbar-thumb': { backgroundColor: '#3F69F8', borderRadius: 3 },
              flexDirection: isBigScreen ? 'row' : 'column',
            }}
          >
            <UserManualNew />
          </Box>
        </Box>
      )}
    </>
  );
};

export default UserManualNewPage;
